import { Controller } from "@hotwired/stimulus"

// Submits the form it's attached to as soon as it renders — for work that has to start when a
// view opens but must not run on a GET (a state-changing, CSRF-protected POST the page fires
// itself). Connects to data-controller="auto-submit".
export default class extends Controller {
  connect() {
    // requestSubmit keeps Turbo in the loop, so the response still targets the enclosing frame.
    requestAnimationFrame(() => this.element.requestSubmit())
  }
}
